import { Stack } from '@mui/material';
import { ChatListItem } from '../../components/chat';
import { ScreenError, SoloLoading } from '../../components';
import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';
import type { HydraCollection } from '../../types';
import { Api } from '../../api';

type Props = {
  type: 'active' | 'broadcast' | 'archived';
  params: any;
};

export default function ChatList({ type, params }: Props) {
  const { search, ...apiParams } = params;
  const dataUrl = `/chat-conversations/clinician/${type}${makeQueryString(apiParams)}`;

  type ChatUnion =
    | Api.ChatConversation.V_Active
    | Api.ChatConversation.V_Broadcast
    | Api.ChatConversation.V_Archived;
  const dataApi = useApiRead<HydraCollection<ChatUnion>>(dataUrl);

  if (dataApi.error) return <ScreenError {...dataApi} />;
  if (!dataApi.data) return <SoloLoading />;
  const allItems = dataApi.data.member ?? [];

  // Filter items client-side based on search
  const filteredItems = search
    ? allItems.filter((chat) => {
        const userName = chat.user?.name || '';
        const teamName = (chat as any).team?.name || '';
        const searchTerm = search.toLowerCase();
        return (
          userName.toLowerCase().includes(searchTerm) ||
          teamName.toLowerCase().includes(searchTerm)
        );
      })
    : allItems;

  return (
    <Stack spacing={0}>
      {filteredItems.map((chat) => (
        <ChatListItem key={chat['@id']} type={type} chat={chat as any} />
      ))}
    </Stack>
  );
}
